import { SxProps } from '@mui/material/styles';

export const RecipientInfoDepotTitleSx: SxProps = {
  fontWeight: 700,
  mb: 2,
  position: 'relative',
};
